import { useRef, useEffect } from "react";

// Hook used to handle whether the component is mounted or not
// to prevent memory leaks
export default function useCheckMountedStatus() {
	// We can't use a local variable here because it will be lost and re-initiated on each update render
	const _isMounted = useRef(true);

	useEffect(() => {
		return () => {
			_isMounted.current = false;
		};
	}, []);

	return { _isMounted };
}
